export default __webpack_public_path__ + "static/neckband_m-66a47f0e56d3c79b5bc6b790d6d9b80f.png";